import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import EncabezadoComprobante from "./EncabezadoComprobante";
import { useForm } from "../../../../Base/Hooks/useForm";
import { getDetallesEncabezado, getEncabezadoById, ObtenerNoRetencion } from "../../../../API/Finanzas/Retencion/ComprobanteRetencionRequest";
import {
  getConceptoRetencion,
  getCuentasHijas,
} from "../../../../API/Finanzas/Retencion/ConceptoRetencionRequest";
import { getRangosDocumentos } from "../../../../API/Finanzas/RegistroContable/RangosDocumentosRequest";
import { getProveedorAct } from "../../../../API/Compras/Proveedores/ProveedoresRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { ObtenerCurrency } from "../../../../Base/API/Global/Currency/CurrencyRequest";
import { getTasaCambio } from "../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import Loader from "../../../../Base/Components/Loader/Loader";

const ComprobanteRetencionCRUD = ({
  showDialog,
  setShowDialog,
  selectedEncabezado,
  setSelectedEncabezado,
  getInfo
}) => {
  const [conceptos, setConceptos] = useState([]);
  const [rangos, setRangos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [estados, setEstados] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [tasaCambio, setTasaCambio] = useState([]);
  const [habilitar, setHabilitar] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [encontrar, setEncontrar] = useState(false);


  const initialValues = {
    IdComprobanteRetencionEnc: -1,
  };

  const { values, setValues, handleInputChange, resetForm, error, setError } = useForm(initialValues);

  const getValoresInicicales = async () => {
    setLoading(true);
    const conceptosTempo = await getConceptoRetencion();
    setConceptos(conceptosTempo);

    const rangosTempo = await getRangosDocumentos();
    console.log(rangosTempo);
    setRangos(
      rangosTempo.filter((e) => e.IdTipoRango === 40 && e.IdStatus === 84)
    );

    const proveedoresTempo = await getProveedorAct();
    setProveedores(proveedoresTempo);

    const estadosTempo = await getEstadosCategory("Retencion");
    setEstados(
      estadosTempo.filter((e) => e.IdStatus === 89 || e.IdStatus === 91)
    );

    const monedasTempo = await ObtenerCurrency();
    setMonedas(monedasTempo);

    const tasaTempo = await getTasaCambio();
    setTasaCambio(tasaTempo[0]?.TasaCambio);

    const cuentasTempo = await getCuentasHijas();
    setCuentas(cuentasTempo);

    const encabezado = selectedEncabezado?.[0];

    if (encabezado?.IdComprobanteRetencionEnc > 0) {
      setEncontrar(true)
      const datos = await getEncabezadoById(encabezado?.IdComprobanteRetencionEnc);
      setSelectedEncabezado(datos);
      
      const result = await getDetallesEncabezado(encabezado?.IdComprobanteRetencionEnc);
      setData(result);
      setValues({
        ...encabezado,
        NoComprobanteRetencion: encabezado?.NoComprobanteRetencion,
        IdEstado: encabezado?.IdEstado,
        FechaEmision: new Date(encabezado?.FechaEmision),
        FechaVencimiento: new Date(encabezado?.FechaVencimiento),
      });
      if (encabezado?.IdEstado === 91 || encabezado?.IdEstado === 92) {
        setHabilitar(true);
      }else{
        setHabilitar(false);
      }
    } else {
      const noRetencionTempo = await ObtenerNoRetencion();
      setValues({
        ...initialValues,
        NoComprobanteRetencion: noRetencionTempo[0]?.NoRetencion,
        FechaEmision: new Date(),
        IdEstado: 89,
        StatusName: "Pendiente de Entrega",
        IdMoneda: 2,
        Currency: "Lempira",
        TasaCambio: tasaCambio,
        PrefijoRango: rangosTempo.find((e) => e.IdTipoRango === 40 && e.IdStatus === 84)
      });
      setHabilitar(false);
    }
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    setSelectedEncabezado([]);
    setData([]);
    resetForm();
    setError({});
  };

  useEffect(() => {
    if (showDialog) {
      getValoresInicicales();
    }
  }, [showDialog]);

  return (
    <div>
      <Dialog
        visible={showDialog}
        onHide={onHide}
        maximizable={true}
        maximized={true}
        header={<h3>Comprobante de Retención</h3>}
      >
        <Loader loading={loading}/>
        <EncabezadoComprobante
          values={values}
          setValues={setValues}
          handleInputChange={handleInputChange}
          conceptos={conceptos}
          rangos={rangos}
          proveedores={proveedores}
          estados={estados}
          monedas={monedas}
          cuentas={cuentas}
          habilitar={habilitar}
          getValoresInicicales={getValoresInicicales}
          getInfo={getInfo}
          data={data}
          setData={setData}
          error={error} 
          setError={setError}
          encontrar={encontrar}
        />
      </Dialog>
    </div>
  );
};

export default ComprobanteRetencionCRUD;
